import { render } from "./DeptLogin.vue?vue&type=template&id=0ed839dd&scoped=true"
import script from "./DeptLogin.vue?vue&type=script&lang=js"
export * from "./DeptLogin.vue?vue&type=script&lang=js"

import "./DeptLogin.vue?vue&type=style&index=0&id=0ed839dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed839dd"]])

export default __exports__